export default __webpack_public_path__ + "static/media/data.54e79bcb.txt";